import { useQuery } from '@tanstack/react-query';
import { ENTITY } from './entity';
import axios, { setTokenToAxios } from '../axios';
import { AuthProviderEnum, TError, TProfile } from '@onesource/schemas';
import { getActiveAuthProvider } from '../auth/auth-provider-utils';

export const getUsersQueryKey = () => {
  return [ENTITY];
};

export const queryFn = async (): Promise<TProfile> => {
  const authProvider = getActiveAuthProvider();
  const url = authProvider === AuthProviderEnum.supabase ? '/auth/auth-check' : ENTITY;
  const response = await axios.get<TProfile>(url);
  return response.data;
};

type TParams = {
  token?: string | null;
};

export const useGetAllProfileQuery = (params?: TParams) => {
  const token = params?.token;
  const isEnabled = !!token?.length;

  if (token) {
    setTokenToAxios(token);
  }

  return useQuery<TProfile, TError>({
    queryKey: getUsersQueryKey(),
    queryFn,
    enabled: isEnabled,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchInterval: 3 * 60 * 60 * 1000, // 3 hours
  });
};

export type TUseGetProfileQueryResult = ReturnType<typeof useGetAllProfileQuery>;
